"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpoint = void 0;

var _react = require("react");

var _context = require("./context");

var useBreakpoint = function useBreakpoint() {
  var value = (0, _react.useContext)(_context.BreakpointContext);

  if (value) {
    return value.breakpoint;
  }

  throw new Error('Please make sure that you wrapped your component with BreakpointProvider.');
};

exports.useBreakpoint = useBreakpoint;